import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon } from 'ctm-components';
import { getSelectedMakeIfPopular } from '../../core/state_selectors';
import styles from '../progress_footer/progress_footer.css';

/**
 * Renders a car make image or generic ctm_car icon depends on if selected make is popular or not
 * @param {String} imageCode - the car make code, e.g. AUDI, BMW
 * @returns {Node} a Icon component or a image
 * @constructor
 */
const _CarBrandIcon = ({ imageCode }) => {
    if (imageCode) {
        const path = `/evt/assets/car-insurance/images/logos/car-insurance/makes/${imageCode}.png`;
        return <img src={path} alt={imageCode} className={styles.brand_logo} />;
    }
    return <Icon className={styles.icon} variant="ctm_car" size="xxxlarge" />;
};

_CarBrandIcon.propTypes = {
    imageCode: PropTypes.string
};

/**
 * Maps the store state to props
 * @param {Immutable.Map} state - The application state
 * @returns {Object} - Required props
 */
const mapStateToProps = (state) => ({
    imageCode: getSelectedMakeIfPopular(state)
});

const CarBrandIcon = connect(mapStateToProps)(_CarBrandIcon);

export { CarBrandIcon, _CarBrandIcon };
